module.exports = __webpack_public_path__ + "static/heritage-95beda12fd13a986851d27887b65f1ab.webp";